import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../icon/svg/upgrade-arrow-icon';
import {Link} from '../link/link';
import {Popover} from '../popover/popover';

import styles from './upgrade-arrow.module.css';

type Props = {
    featureName: string;
    title?: string;
    onClick?: () => void;
};

export function UpgradeArrow(props: Props) {
    const popoverRef = React.useRef(null);
    const [isPopoverShown, setIsPopoverShown] = React.useState<boolean>(false);

    return (
        <>
            <div
                ref={popoverRef}
                onClick={() => {
                    if (props.onClick) {
                        props.onClick();
                    } else {
                        setIsPopoverShown(true);
                    }
                }}
            >
                <UpgradeArrowIcon className={styles['upgrade-arrow']} size={16} />
            </div>
            {isPopoverShown ? (
                <Popover
                    isNubDark={true}
                    bodyColor='dark'
                    onBlur={() => setIsPopoverShown(false)}
                    anchor={popoverRef.current}
                >
                    <div className={styles['upgrade-arrow-popover']}>
                        <div>
                            {props.title
                                ? props.title
                                : 'This feature isn’t available in your current plan.'}
                        </div>
                        <Link
                            newTab={true}
                            size='small'
                            variant='primary'
                            href='/setup/billing/sales'
                        >
                            Learn more about {props.featureName} in our pricing plans.
                        </Link>
                    </div>
                </Popover>
            ) : undefined}
        </>
    );
}
